(function(angular) {
    'use strict';
    /**
     * This is the controller for the Activity Feed view. Don't be mislead by the name "analytics" in this codebase.
     */
    angular.module('GorillaBoy.OfficeEditor')
        .factory('OfficeEditorController', [
            '$rootScope',
            'SourceConstant',
            'AppConstants',
            '$translate',
            '$location',
            '$sce',
            '$timeout',
            '$q',
            '$log',
            '$window',
            '$routeParams',
            'MetricEvents',
            'FeatureManagerService',
            'AuthService',
            'Features',
            'ClientMetricsService',
            'WopiService',
            'TokenService',
            'localStorageService',
            'SignalProvider',
            OfficeEditorController
        ]);

    function OfficeEditorController($rootScope,
            SourceConstant,
            AppConstants,
            $translate,
            $location,
            $sce,
            $timeout,
            $q,
            $log,
            $window,
            $routeParams,
            MetricEvents,
            FeatureManagerService,
            AuthService,
            Features,
            ClientMetricsService,
            WopiService,
            TokenService,
            localStorageService,
            SignalProvider) {

        var service = {};
        service.initScope = function($scope, userInfo) {

            var Metrics = MetricEvents.O365;

            ClientMetricsService.startLatencyEvent(Metrics.O365_POST_TO_IFRAME_LATENCY);

            $scope.accessTokenError = false;
            $scope.actionUrlError = false;
            $scope.iniationSucceeded = true;
            $scope.currentOfficeVersionId = $scope.documentState.activeVersion.VersionId;

            // if versionId is present in route params, that supersedes the latest version.
            if($routeParams.versionId){
                $scope.currentOfficeVersionId =  $routeParams.versionId;
            }

            $log.log("using versionId : " + $scope.currentOfficeVersionId);

            // event handler for Post message calls from office iFrame.
            $window.onmessage = function(event){
                var message = JSON.parse(event.data);

                // the office iframe has completed loading document.
                if (message.MessageId === "App_LoadingStatus") {
                    var completionTime = message.Values.DocumentLoadedTime,
                        officeSessionId = message.Values.wdUserSession;

                    // The event contains time stamp from UNIX epoch we use time since navigation start so we need to add the navigation Start time to get
                    // meaningful time difference
                    var elapsedTime = completionTime - (window.performance.timing.navigationStart + ClientMetricsService.getLatencyEventStartTime(Metrics.O365_POST_TO_IFRAME_LATENCY));
                    ClientMetricsService.cancelLatencyEvent(Metrics.O365_POST_TO_IFRAME_LATENCY);

                    var loadEvent = { event : Metrics.OFFICE_FRAME_LOAD_COMPLETE.name };

                    loadEvent.documentId = $scope.metadata.Id;
                    loadEvent.versionId = $scope.currentOfficeVersionId;
                    loadEvent.latency = elapsedTime;
                    loadEvent.officeSessionId  = officeSessionId;
                    loadEvent.documentType =  $scope.documentState.activeVersion.ContentType;
                    
                    ClientMetricsService.addEventObjectToSession(loadEvent);
                    return;
                }

                // close message handler
                if(message.MessageId === "UI_Close"){
                    var closeEvent = { 
                        event : Metrics.OFFICE_FILE_CLOSED.name
                    };

                    closeEvent.documentId = $scope.metadata.Id;
                    closeEvent.versionId = $scope.currentOfficeVersionId;
                    closeEvent.officeSessionId = message.Values.wdUserSession;
                    closeEvent.documentType =  $scope.documentState.activeVersion.ContentType;

                    ClientMetricsService.addEventObjectToSession(closeEvent);

                    $timeout(function() {
                        if($routeParams.siteReturnPath){
                            // edit is complete reload this route in view mode.
                            window.location.hash = $routeParams.siteReturnPath;
                        } else {
                            window.location.hash = '#/document/' + $scope.metadata.Id;
                        }
                    });
                    return;

                }

                if(message.MessageId === "EDIT_NOTIFICATION"){
                    // To be implemented.
                    return;
                }
            };

            $scope.$on('$destroy', function(){
                $window.onmessage = null;
            });

            $scope.wopiAccessKeyExpiration = getAccessTokenTtl();

            // Refresh acces token to ensure that the access token is as fresh as possible before starting
            // a new session.
            ClientMetricsService.startLatencyEvent(Metrics.ACCESS_TOKEN_FETCH_LATENCY);
            AuthService.refreshAccessToken().then(function(){
                TokenService.createSecureToken($scope.metadata.Id, $scope.currentOfficeVersionId, $routeParams.siteReturnPath).then(function(wopiToken) {
                    $scope.wopiAccessKey = wopiToken;
                    ClientMetricsService.stopAndRecordLatencyEvent(Metrics.ACCESS_TOKEN_FETCH_LATENCY);

                    ClientMetricsService.startLatencyEvent(Metrics.ACTION_URL_FETCH_LATENCY);
                    WopiService.getActionUrl(getDocumentType(), getDocumentType() !== WOPI_TEST_FILE_CONTENT_TYPE ? "edit" : "view",
                        window.determinePreferredLanguage().toLowerCase(), ClientMetricsService.getCurrentSessionId())
                        .then(function(response) {
                            ClientMetricsService.stopAndRecordLatencyEvent(Metrics.ACTION_URL_FETCH_LATENCY);
                            var responseObject = response.data;
                            $scope.baseUrl = responseObject.ActionUrl;
                            $scope.actionUrl = $sce.trustAsResourceUrl($scope.baseUrl + '&WOPISrc=' + WopiService.getFileEndpointUrl($scope.metadata.Id) +
                                    '&sc=' + encodeURIComponent(ClientMetricsService.getCurrentSessionId()));

                            if(responseObject.FaviconUrl){
                                $scope.favicon =  responseObject.FaviconUrl;
                            }

                            $timeout(function(){
                               $rootScope.$broadcast('submitForm', null);
                               ClientMetricsService.recordLatencyEvent(Metrics.O365_POST_TO_IFRAME_LATENCY);
                            });
                        }, function(error){
                            $scope.actionUrlError = true;

                            var actionUrlEvent = Metrics.ACCESS_TOKEN_FETCH_FAILED;

                            actionUrlEvent.documentId = $scope.metadata.Id;
                            actionUrlEvent.versionId = $scope.currentOfficeVersionId;
                            ClientMetricsService.addEventObjectToSession(actionUrlEvent);

                            recordPageFailed();
                        });
                }, function(errorResponse){
                    $scope.accessTokenError =  true;

                    var accessTokenEvent = Metrics.ACCESS_TOKEN_FETCH_FAILED;

                    accessTokenEvent.documentId = $scope.metadata.Id;
                    accessTokenEvent.versionId = $scope.currentOfficeVersionId;
                    ClientMetricsService.addEventObjectToSession(accessTokenEvent);
                    recordPageFailed();
                });
            });

            function recordPageFailed() {
                var pageFailEvent = Metrics.OFFICE_PAGE_INITIALIZATION_FAILED;

                pageFailEvent.documentId = $scope.metadata.Id;
                pageFailEvent.versionId = $scope.currentOfficeVersionId;

                ClientMetricsService.addEventObjectToSession(pageFailEvent);
                $scope.iniationSucceeded = false;
            }

            var WOPI_TEST_FILE_CONTENT_TYPE = "application/wopitest";
            function getDocumentType(){
                if(_.endsWith($scope.metadata.VersionMetadata.Name, AppConstants.WOPI_TEST_EXT)){
                    return WOPI_TEST_FILE_CONTENT_TYPE;
                }
                return $scope.metadata.VersionMetadata.ContentType;
            }


            function getAccessTokenTtl(){
                // number of ticks for one week.
                var timeOffsetTicks = 7*24*60*60*1000;

                return Date.now() + timeOffsetTicks;
            }
        };
        return service;
    }
}(angular));


